export const GET_SETTINGS = 'VIOLATION_FEES/get_settings';
export const GET_SINGLE_SETTING = 'VIOLATION_FEES/get_single_setting';
export const UPDATE_SETTING = 'VIOLATION_FEES/update_setting';
export const CREATE_SETTING = 'VIOLATION_FEES/create_setting';
export const REMOVE_SETTING = 'VIOLATION_FEES/remove_setting';

export const GET_ROLE_LIST = 'ROLE/get_role_list';

export const FORM_DATA = {
  barangay_number: '',
  zone_number: '',
  district_number: '',
  name: '',
};

export const SOURCE = [
  { label: 'CSV', value: 'CSV' },
  { label: 'API', value: 'API' },
  { label: 'MANUAL', value: 'MANUAL' },
];
